module.exports = __webpack_public_path__ + "static/img/headerImgEn.5ddebd42.png";